/* CAMODE - Lightweight, price-only Klarna installment calculator.
 * No network requests, no checkout integration, no navigation, no changes to the actual Shopify price.
 * Uses the same collection-based discounted display-price rule as the PDP.
 * Shopify variantChange PubSub updates the displayed example when the chosen size/variant changes.
 */
(function () {
  'use strict';
  if (window.__cmKlarnaInstallmentsBound) return;
  window.__cmKlarnaInstallmentsBound = true;

  function euro(amount, currency) {
    var code = currency || 'EUR';
    try {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency', currency: code,
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(amount / 100);
    } catch (e) { return (amount / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  function calculate(priceCents, discountPct) {
    var base = Number(priceCents);
    var percent = Number(discountPct);
    if (!Number.isFinite(base) || base < 0) return null;
    if (!Number.isFinite(percent) || percent < 0 || percent > 100) percent = 0;
    var total = Math.round(base * (100 - percent) / 100);
    var first = Math.floor(total / 3);
    return { total: total, first: first, second: first, third: total - 2 * first };
  }

  function update(root, priceCents) {
    if (!root || !root.isConnected) return;
    var data = calculate(priceCents, root.dataset.cmKlarnaDiscount);
    if (!data) return;
    root.dataset.cmKlarnaBasePrice = String(priceCents);
    var currency = root.dataset.cmKlarnaCurrency || 'EUR';
    var nearest = root.nextElementSibling;
    if (!nearest || !nearest.matches('dialog.cm-klarna-info-dialog')) return;
    var pairs = [
      [root.querySelector('[data-cm-klarna-rate]'), data.first],
      [nearest.querySelector('[data-cm-klarna-total]'), data.total],
      [nearest.querySelector('[data-cm-klarna-first]'), data.first],
      [nearest.querySelector('[data-cm-klarna-second]'), data.second],
      [nearest.querySelector('[data-cm-klarna-third]'), data.third]
    ];
    pairs.forEach(function (pair) { if (pair[0]) pair[0].textContent = euro(pair[1], currency); });
  }

  function onVariant(event) {
    var payload = event && event.data;
    var section = payload && payload.sectionId;
    var variant = payload && payload.variant;
    if (!section || !variant || !Number.isFinite(Number(variant.price))) return;
    var productInfo = Array.from(document.querySelectorAll('product-info[data-section]'))
      .find(function (el) { return el.dataset.section === String(section); });
    if (!productInfo) return;
    var banner = productInfo.querySelector('.cm-klarna-pdp[data-cm-klarna-product]');
    if (banner) update(banner, variant.price);
  }

  function init() {
    document.querySelectorAll('.cm-klarna-pdp[data-cm-klarna-base-price]').forEach(function (root) {
      update(root, root.dataset.cmKlarnaBasePrice);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariant);
    }
    document.addEventListener('product-info:loaded', function (e) {
      if (e.target && e.target.querySelector) {
        var banner = e.target.querySelector('.cm-klarna-pdp[data-cm-klarna-base-price]');
        if (banner) update(banner, banner.dataset.cmKlarnaBasePrice);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
